<template>
  <div class="accept-container" 
       v-title
       :data-title="this.$t('title.all')+this.$t('title.mine')">
    <LoginModel v-if="loginIn"></LoginModel>
    <Navbar></Navbar>
    <ScrollTop></ScrollTop>
    <div class="container container-position">
       <div class="user-info-header">
            <span @click="changeHeader"
                   v-bind:class="{'hover':addHeaderClass}">{{headerTitle}}</span>
            <img class="avatar" 
                :src="user['avatar']">
        </div>
        <div  v-bind:class="['mine-tabar',{'addHeaderList':addHeaderClass}]">
          <div class="user-info">
            <router-link to = '/mine/personal'>
               <img :src="user['avatar']"
                    alt="" class="user-headpoirt"/></router-link>
            <router-link to="/mine/vip"><p v-bind:class="[{
                'vip-have':user['isVip']},'user-statate','vip']">
            </p></router-link>
            <router-link to = '/mine/personal'><h6 class="user-name">{{user['username']}}</h6></router-link>
            <p class="user-caiyunpoints"
               @click="showPoint">
              <img src="../assets/points.png" alt="">
              <span>{{user['point']}}</span>
            </p>
          </div>
          <el-menu :default-active="this.$route.path"
                   class="min-tabar"
                   mode="vertical"
                   @select="handleSelect"
                   :router="true">
            <div :class="['en-mine-bar-tab',{'isEngCss':isChinese}]">
               <el-menu-item v-for="(o, index) in NavData"
                            :key="index"
                            class="menu-item"     
                            @click="changeList(index)"  
                            :index="o.url">{{o.title}}</el-menu-item>
              <!-- <el-menu-item class="menu-item"
                            index="/mine/doc">{{$t('my.nav.doc')}}</el-menu-item>
              <el-menu-item class="menu-item"
                            index="/mine/favorite">{{$t('my.nav.collection')}}</el-menu-item>
              <el-menu-item class="menu-item"
                            index="/mine/translation">{{$t('my.nav.translator')}}</el-menu-item>
              <el-menu-item class="menu-item"
                            index="/mine/history">{{$t('my.nav.history')}}
              </el-menu-item>
              <el-menu-item class="menu-item"
                            index="/mine/vip">{{$t('my.nav.vip')}}</el-menu-item>
              <el-menu-item class="menu-item"
                            index="/mine/personal">{{$t('my.nav.personal')}}</el-menu-item> -->
            </div>
          </el-menu>
        </div>
        <router-view></router-view>
      </div>
      <IconModel  ref="myPoint"></IconModel>
  </div>
</template>
<style scoped>
  .add_bg{
    background: #ebf1ed;
  }
  .container-position{
    position: relative;
    padding-right: 0px !important;
    /* padding-left:115px; */
    padding-left: 145px;
    min-width: 750px;
  }
  .el-menu-item{
    height: 42px;
    line-height: 42px;
  }
  .mine-tabar{
    width: 150px;
    position: fixed;
    /*margin-left: 0px;*/
    margin-left:-145px;
    text-align: center;
    z-index: 100;
  }
  .mine-tabar.addHeaderList{
    display: block;
  }
  .mine-tabar .el-menu{
    height:auto;
    border:none;
  }
  .mine-tabar .el-menu-item{
    margin-right: 0;
    width:150px;
  }
  .mine-tabar .el-menu-item{
    background: #f6faf8;
    border-bottom: 2px solid #ffffff;
  }
  .mine-tabar .el-menu-item:last-child{
    border-bottom: none;
  }
  .mine-tabar .el-menu-item.is-active {
    background: #fff;
    color:#000;
  }
  .mine-tabar .el-menu-item:hover, .mine-tabar .el-menu-item:focus {
    outline: none;
    background: #fff;
    color:#000;
  }
  .mine-tabar .user-info{
    background-color: #f6faf8;
    text-align: center;
  }
  .mine-tabar .user-headpoirt{
    height:60px;
    width:60px;
    border-radius: 50%;
    overflow: hidden;
    margin: 20px auto 10px;
  }
  .mine-tabar .user-name{
    margin-top: 10px;
    font-size: 14px;
    color: #9fa1a0;
    margin-bottom: 0;
    word-break: break-word;
    padding: 0 15px 15px;
  }
  .mine-tabar .vip{
    width:45px;
    height:16px;
    margin: 0 auto;
    background-image: url("../assets/vip-none.png");
    background-repeat:no-repeat;
    background-size: contain;
  }
  .mine-tabar .vip.vip-have{
    background-image: url("../assets/vip-have.png");
  }
  .user-caiyunpoints{
    margin: 0;
    color: #FEA310;
    font-size: 14px;
    height: 20px;
    line-height: 20px;
    padding-bottom: 8px;
    border-bottom: 1px solid #fff;
    cursor: pointer;
  }
  .user-caiyunpoints >img{
    width:20px;
    display: inline-block;
    vertical-align: bottom;
    margin-right: 5px;
  }
  .user-info-header{
    position: fixed;
    height: 60px;
    z-index: 999;
    top: 0;
    left: 0;
    right: 0;
    /* width:100%; */
    background: #fff;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    padding-left: 20px;
    padding-right: 20px;
    display: none;
  }
  .user-info-header > .avatar{
    position: absolute;
    cursor: pointer;
    right: 20px;
    top: 50%;
    z-index: 1000;
    border-radius: 20px;
    height: 40px;
    width: 40px;
    margin-top: -20px;
    overflow: hidden;
  }
  .user-info-header>span{
    font-size: 1.15385em;
    color: #333;
    position: absolute;
    left: 20px;
    top:50%;
    transform: translateY(-50%);
  }
  .user-info-header>span.hover::before{
    transform: rotate(180deg);
  }
  .user-info-header>span::before{
    position: absolute;
    display: block;
    content: '';
    right: -25px;
    top: 50%;
    width: 30px;
    height: 16px;
    margin-top: -8px;
    background:url('../assets/xia-icon.png') no-repeat;
    background-position: center center;
    background-size: contain;

    transition: transform .2s;
    -moz-transition: transform .2s; /* Firefox 4 */
    -webkit-transition: transform .2s; /* Safari 和 Chrome */
    -o-transition: transform .2s; /* Opera */
  }

  @media (max-width: 650px) {
    .mine-tabar{
      top: 60px;
      width: 150px;
      left: 0;
      margin: 0;
      z-index: 9999999;
      position: fixed;
      display: none;
    }
    .min-tabar >div{
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    }
    .mine-tabar .user-info{
      display:none;
    }
    .container-position{
      padding-left: 0;
      min-width: auto;
    }
    .container-box{
      margin-left: 0;
      padding-top: 65px;
    }
    .mine-tabar .el-menu-item{
      margin-left: 0;
      float: inherit;
    }
    .user-info-header{
      display: block
    }
  }
</style>
<script>
  import { getUserData,USER_INFO } from '@/api/user'
  import { whatLang } from '@/utils/index'
  import LoginModel from '../components/LoginModel'
  import Navbar from '../components/Navbar'
  import IconModel from '../components/IconModel';
  import ScrollTop from '../components/ScrollTop';
  import {getSignature,isWeixin} from '@/api/weixin';

  export default {
    name: 'mine',
    components:{Navbar,LoginModel,IconModel,ScrollTop},
    data() {
      return {
        url: '',
        avatarUrl: "",
        activeIndex: "",
        avatarName :'',
        loginIn:false,
        user:{},
        addHeaderClass:false,
        headerTitle:'',
        NavData:[
          {
            title:this.$t('my.nav.doc'),
            url:'/mine/doc'
          },
          {
            title:this.$t('my.nav.collection'),
            url:'/mine/favorite'
          },
          {
            title:this.$t('my.nav.translator'),
            url:'/mine/translation'
          },
          {
            title:this.$t('my.nav.history'),
            url:'/mine/history'
          },
          {
            title:this.$t('my.nav.vip'),
            url:'/mine/vip'
          },
          {
            title:this.$t('my.nav.personal'),
            url:'/mine/personal'
          }
        ],
        isChinese:whatLang() !='zh'
      }
    },
    beforeCreate: function() {
      document.getElementsByTagName("body")[0].className="add_bg";
    },
    beforeDestroy: function() {
      document.body.removeAttribute("class","add_bg");
    },
    created() {
      this.user = USER_INFO();
      this.changeUrlTitle();
      if(!this.user['_id']){
        console.log('未登陆');
        if(isWeixin()){
          this.wechatAuthorize();
        }else{
          window.location.href = 'https://www.caiyunapp.com/user/login';
        }
      }
       getSignature();
      
    },
    mounted() {

    },
    methods: {
      showPoint:function () {
        this.$refs.myPoint.show(this.user['_id']);
      },
      handleSelect(key, keyPath) {

      },
      changeHeader(){
          this.addHeaderClass = !this.addHeaderClass;
      },
      changeList(i){
        this.addHeaderClass = false;
        this.headerTitle = this.NavData[i].title;
      },
      changeUrlTitle(){
        const url = this.$route.path;
        // headerTitle
        for(let i = 0 ; i < this.NavData.length ; i ++){
          if(this.NavData[i].url == url ){
            this.headerTitle = this.NavData[i].title;
            break; 
          }
        }
      },
      //打开微信oauth2页面，用户同意授权，获取code
      wechatAuthorize() {
  //重定向URL
        var re_uri = encodeURIComponent("https://www.caiyunapp.com/wechat_login?re_url=" + location.href);
        var url = "https://open.weixin.qq.com/connect/oauth2/authorize?" +
      "appid=wx9b768083e39b41f5&redirect_uri=" + re_uri + "&response_type=code&scope=snsapi_userinfo&state=LOGIN#wechat_redirect";
        location.href = url;
},

//通过code换取网页授权access_token，通过access_token获取用户信息，之后步骤必须在服务器进行
    wechat_login(code) {
       $.ajax({
        url: wechat_login_API+"?lonlat="+center[1] + "," + center[0] + "&code=" + code,
        type: "GET",
        dataType: "jsonp",
        contentType: "application/json",
        timeout: 5000,
        success: function (res) {
            //showGuessData(res, 1);
      var result = res.result;
      //alert("wechat_login: " + JSON.stringify(res));
      //console.log("wechat_login result:", res)
      if (res.status == "ok") {
        // showUser(result);
      } else {
        console.error("wechat_login failed", result)
        //alert("wechat_login failed" + JSON.stringify(result));
        this.wechatAuthorize();
      }
    },
    error: function (e) {
      console.error(e);
      // alert("wechat_login error" + e.toString() +  JSON.stringify(e));
      //wechatAuthorize();
    }
  });
}
    }
  }

</script>



// WEBPACK FOOTER //
// src/pages/mine.vue